const env = {
  apiUrl: 'https://eva-az-dev.2rpnet.io/api/ceaportal/',
  language: 'pt',
};

export default env;
